import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/authStore'

interface ProtectedRouteProps {
  children: React.ReactNode
  roles?: string[]
}

export default function ProtectedRoute({ children, roles }: ProtectedRouteProps) {
  const { isAuthenticated, user, impersonation } = useAuthStore()

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace />
  }

  if (roles && user) {
    const userRole = user.role?.toUpperCase()
    const hasAccess = roles.some(role => role.toUpperCase() === userRole)

    // Allow impersonating admins through vendor-gated routes
    if (!hasAccess && !impersonation.active) {
      return <Navigate to="/dashboard" replace />
    }
  }

  return <>{children}</>
}

